import { DataTable, PageWrapper, STATUSPAGE } from '@repo/ui';
import { useFormik } from 'formik';
import { useLegends } from 'presentation/app/hooks/useLegends';
import { useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import * as Yup from 'yup';

import { makeColumnsStudentsList } from '../../common/columns/columns-students-list';
import { StudentsFilters } from '../../components/students-filters';
import { useStudentsList } from '../../hooks/useStudentsList';

export const StudentsList = () => {
  // Hooks
  const { getLegends } = useLegends();
  const {
    studentsListData,
    studentsListFilters,
    paginationMetadata,
    listLoadingStatus,
    debouncedRequestGetAllStudents,
    setListLoadingStatus,
    saveStudentsListFilters,
    handlePageChange,
    handleRowsPerPageChange,
    handleSortRemote,
    handleSearchRemote,
  } = useStudentsList();

  const validation = useFormik({
    initialValues: {
      entity: studentsListFilters?.entity || null,
      course: studentsListFilters?.entity || null,
      curricularUnit: studentsListFilters?.curricularUnit || null,
      group: studentsListFilters?.group || null,
      semester: studentsListFilters?.semester || null,
      local: studentsListFilters?.local || null,
      inGroup: studentsListFilters?.inGroup || null,
    },
    validationSchema: Yup.object({
      entity: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      semester: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      unit: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      group: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable(),
      ),
      local: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      inGroup: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
    }),

    // There is no onSubmit function on this form (no submit button).
    // The API request is sent everytime any filter changes, so it is controlled via useEffect and DataTable's remote pagination.
    onSubmit: () => {
      return;
    },
  });

  // useEffect responsible for calling API and fetching DataTable's data
  useEffect(() => {
    const valuesToSubmit = {
      entity: validation.values?.entity?.value,
      course: validation.values?.course?.value,
      semester: validation.values?.semester?.value,
      curricularUnit: validation.values?.curricularUnit?.value,
      group: validation.values?.group?.value,
      local: validation.values?.local?.value,
      page: paginationMetadata.selectedPage.toString(),
      length: paginationMetadata.rowsPerPage.toString(),
      order: paginationMetadata.sortDirection,
      orderColumn: paginationMetadata.orderColumn,
      query: paginationMetadata.searchString,
      inGroup: validation?.values?.inGroup?.value,
    };
    setListLoadingStatus(STATUSPAGE.LOADING);
    saveStudentsListFilters(validation.values);
    debouncedRequestGetAllStudents(valuesToSubmit);
  }, [
    validation.values?.entity,
    validation.values?.course,
    validation.values?.curricularUnit,
    validation.values?.semester,
    validation.values?.group,
    validation.values?.local,
    validation.values?.inGroup,
    paginationMetadata,
  ]);

  // Constants
  const noDataConfig = {
    noDataTitle: 'Nenhum estudante encontrado',
    noDataDescription:
      'Use os filtros acima para pesquisar estudantes por nome, grupo ou local de estágio.',
  };

  return (
    <PageWrapper title={getLegends('ESTUDANTE', true)}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>{getLegends('ESTUDANTE', true)}</h4>
        {/* <button
          type="submit"
          className="btn btn-primary waves-effect waves-light d-flex align-items-center gap-1"
        >
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>
          Novo {getLegends('ESTUDANTE')}
        </button> */}
      </div>
      <Card>
        <StudentsFilters validation={validation} />

        <CardBody>
          <DataTable
            noDataTitle={noDataConfig.noDataTitle}
            noDataDescription={noDataConfig.noDataDescription}
            actions={[]}
            canSearch
            searchServer
            onSearch={handleSearchRemote}
            columns={makeColumnsStudentsList()}
            data={studentsListData?.data}
            loading={listLoadingStatus === STATUSPAGE.LOADING}
            pagination
            paginationServer
            paginationTotalRows={studentsListData?.total}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            sortServer
            onSort={handleSortRemote}
          />
        </CardBody>
      </Card>
    </PageWrapper>
  );
};
